/* eslint-disable react-hooks/exhaustive-deps */
import {Trans} from '@lingui/macro';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  IconButton,
  InputAdornment,
  Link,
  makeStyles,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import {login} from 'features/login/actions';
import React from 'react';
import {connect} from 'react-redux';
import {Redirect, Link as RouterLink} from 'react-router-dom';
import {i18n2} from 'features/i18n/i18n';
import {isSessionExpired} from '../../helpers/session';

function Copyright() {
  return (
    <Box mt={8}>
      <Typography variant="body2" color="textSecondary" align="center">
        {'E-Learning © '}
        <Link color="inherit" href="/">
          Mox IT
        </Link>{' '}
      </Typography>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  logo: {
    width: '100%',
    maxWidth: '500px',
    height: 'auto',
    maxHeight: '500px',
    objectFit: 'contain',
    verticalAlign: 'middle',
  },
  message: {
    backgroundColor: 'green',
    color: 'white',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

function Login() {
  const classes = useStyles();
  const [isLoading, setIsLoading] = React.useState(false);
  const [credentials, setCredentials] = React.useState({
    username: null,
    password: null,
  });
  const [message, setMessage] = React.useState({
    open: false,
    text: '',
  });
  const [showPassword, setShowPassword] = React.useState(false);

  const handleChange = (e) => {
    let target = e.target;
    setCredentials((prevState) => {
      return {...prevState, [target.name]: target.value};
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const attemptLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let loginStatus = await login(credentials.username, credentials.password);
    setIsLoading(false);

    if (!loginStatus.ok) {
      setMessage({open: true, text: loginStatus.text});
    } else {
      // Redirigir si requiere cambio de contraseña
      if (sessionStorage.getItem('requirePasswordChange') === 'true') {
        window.location.href = '/change-password';
      }
    }
  };

  if (!isSessionExpired()) {
    // Si requiere cambio de contraseña, forzar redirección
    if (sessionStorage.getItem('requirePasswordChange') === 'true') {
      return <Redirect to="/change-password" />;
    }
    return <Redirect to="/Dashboard" />;
  }

  //Login form
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <img
          src={`${process.env.PUBLIC_URL}/moxit-imagotipo.png`}
          className={classes.logo}
          alt="Mox It Logo"
        />
        <Typography component="h1" variant="h5">
          <Trans>Bienvenido</Trans>
        </Typography>
        <form
          className={classes.form}
          noValidate
          onSubmit={(e) => attemptLogin(e)}>
          <TextField
            variant="outlined"
            margin="normal"
            required={true}
            fullWidth
            label={i18n2._('Usuario')}
            name="username"
            autoFocus
            onChange={(e) => handleChange(e)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required={true}
            fullWidth
            name="password"
            label={i18n2._('Password')}
            type={showPassword ? 'text' : 'password'}
            autoComplete="current-password"
            onChange={(e) => handleChange(e)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label={
                      showPassword
                        ? i18n2._('Ocultar contraseña')
                        : i18n2._('Mostrar contraseña')
                    }
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={handleMouseDownPassword}
                    edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={isLoading}>
            {isLoading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
            <Trans>Iniciar sesión</Trans>
          </Button>
        </form>
        <Link to="/recover-password" component={RouterLink} variant="body2">
          <Trans>Olvidé mi contraseña</Trans>
        </Link>
      </div>
      <Copyright />
      <Snackbar
        open={message.open}
        autoHideDuration={1000}
        onClose={() => setMessage({...message, open: false})}
        bodystyle={classes.message}
        message={i18n2._(message.text ? message.text : '')}
      />
    </Container>
  );
}

const mapStateToProps = (state) => ({
  error: state.authentication.error,
});

export default connect(mapStateToProps)(Login);
